import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-error',
  styles: [`
    @media (min-width:320px) { /* smartphones, iPhone, portrait 480x320 phones */
        .exception-body {
            background-image: url('/assets/images/error_mobile.png') !important;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: 70% !important;
        }
    }

    @media (min-width:481px) { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */
        .exception-body {
            background-image: url('/assets/images/error_pc.png') !important;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: 70% !important;
        }
    }

    @media (min-width:641px) { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
        .exception-body {
            background-image: url('/assets/images/error_pc.png') !important;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: 70% !important;
        }
    }

    @media (min-width:961px) { /* tablet, landscape iPad, lo-res laptops ands desktops */
        .exception-body {
            background-image: url('/assets/images/error_pc.png') !important;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: 70% !important;
        }
    }

    @media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */
        .exception-body {
            background-image: url('/assets/images/error_pc.png') !important;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: 70% !important;
        }
    }

    @media (min-width:1281px) { /* hi-res laptops and desktops */
        .exception-body {
            background-image: url('/assets/images/error_pc.png') !important;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: 70% !important;
        }
    }

    button{
        color: #ffffff;
        background-color: #007ad9;
        border: 0px solid #007ad9;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
        margin-right: 0.5em;
        font-size: 14px;
        transition: background-color 0.2s, box-shadow 0.2s;
        margin: 0;
        border-radius: 3px;
        position: relative;
        padding: 0;
        text-decoration: none!important;
        cursor: pointer;
        text-align: center;
        overflow: visible;
        box-sizing: border-box;
    }

    span{
        width: 18em;
        padding: 0.429em 1em;
        display: block;
        box-sizing: border-box;
        line-height: normal;
        color: #ffffff !important;
        background-color: #007ad9 !important;
        border: 0px solid #007ad9 !important;
    }
  `],
    template:  `<div class="exception-body text-center">
                    <div class="exception-panel" style="height: 100vh;position: absolute;width: 100vw;">
                        <div class="exception-detail" style="padding-top: 5vh;">
                            <div class="exception-icon">
                            </div>
                            <button (click)="home()" type="button" class="ui-button-rounded ui-button-secondary">
                                <span class="ui-button-text">Reintentar</span>
                            </button>
                        </div>
                    </div>
                </div>`
})

export class ServiceUnavalaibleComponent{

    constructor(private router: Router,private toastr: ToastrService){
        this.toastr.error("Sitio en mantenimiento. Servicio temporalmente no disponible.", "Error");
    }

    home() : void{
        this.router.navigate(['home']);
    }

}